export function formatNumberWithCommasAndFontWeight(value) {
    const formattedValue = parseFloat(value).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const parts = formattedValue.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1];
    if (isNaN(value)) {
        return "-";
    }

    return (
        <span>
            {integerPart}.<span style={{ fontWeight: 400 }}>{decimalPart}</span>
        </span>
    );
}